const settings = {
  BOT_TEXT_MAX_LINES: 30,
  TRAILING_MESSAGES_DISPLAYED: 100,
  maintenance: {
    active: false,
    title: "We're undergoing scheduled maintenance",
    message:
      "Please check back soon, just putting the finishing touches on some pretty awesome updates!",
  },
  GA: [
    {
      type: "event",
      name: "testing event",
      payload: {
        event_category: "sample",
        event_label: "SAMPLE LABEL",
        value: 12,
      }, //payload depends on type of event being sent.
    },
  ],
  AUTO_RESTART_SESSION: true,
  ENABLE_FEEDBACK: false,
  HIDE_RESTART_ALERT_ON_FEEDBACK_PAGE: false,
  FEEDBACK_FORM_NAME: "",
  IMG_TEMPLATE_SHOW_FULL: false,
  PERSISTENT_MENU_BUTTON: true,
  WELCOME_SCREEN_SETTINGS: {
    display: false,
    welcomeTitle: "Hello!",
    welcomeMessageMain:
      "I am Pand.ai and I make retrieving financial information easy.",
    welcomeMessageSecondary: "Ask me about anything.",
    actionButton: {
      active: false,
      text: "Button Label",
      secondaryText: "",
      payload: "FL5be7a85b4e2da6b76d7f3b64_0",
    },
  },
  WIDE_MODE: false,
  FULLSCREEN_SMALL_WIDGET: false,
  WIDGET_LOCATION: "right",
  CHAT_OPEN_BY_DEFAULT: false,
  QR_LIMIT: 10,
  QR_SHOW_ALL: false,
  SHOW_USER_FORM_RESPONSE: false,
  SHOW_WATERMARK: false,
  SOCKET_DIALOG: {
    title: "Session has been disconnected.",
    subTitle:
      "Click the button below or refresh the page to restart the session",
    buttonText: "Restart",
  },
  WEBSHARE_IGNORED_QRS: ["5ece45e8b3c31a04fdf4d36e"], //default webshare payload, to hide when webshare is unavailable
  USE_DYNAMIC_QR_LENGTH: false,
  USE_CUSTOM_LAUNCHER_ICON: true,
  USE_CUSTOM_LAUNCHER: true,
  MINIMIZE_LAUNCHER: false,
  CUSTOM_LAUNCHER_HEIGHT: 106,
  CUSTOM_LAUNCHER_WIDTH: 88,
  LAUNCHER_OFFSET_X: 10,
  LAUNCHER_OFFSET_Y: 10,
  LAUNCHER_BUTTON_ID: "launcherButton",
  USE_SESSION: false,
  ENABLE_FILE_UPLOAD: false,
  HEADER_SHOW_NAME: true,
  HEADER_BADGE_STYLE: "rectangle",
  HEADER_MENU: true,
  HEADER_MENU_FOLDED: false,
  HEADER_MENU_ITEMS: [
    { label: "Minimise", icon: "fas fa-times", payload: "minimise" },
  ],
  NAVIGATION_ITEMS: [
    {
      label: "Menu",
      icon: "fas fa-list-alt",
      payload: "FL68d9f16faf6b51bfc2a8d775_0",
    },
    // {
    //   label: "Change Language",
    //   icon: "fas fa-globe",
    //   payload: "FL693fc38ab5ae080dc39e54ce_0",
    // },
    {
      label: "Octo Biz",
      icon: "fas fa-briefcase",
      payload: "FL692fa07b46183771f4ab2d46_0",
    },
    {
      label: "Products",
      icon: "fas fa-shopping-bag",
      payload: "FL692fa08c46183771f4ab2d54_0",
    },
    {
      label: "Solutions",
      icon: "fas fa-lightbulb",
      payload: "FL692fa0a346183771f4ab2d62_0",
    },
  ],

  //////////////////////////////////////////////////////////////////////////////////////////////////////////
  //                                           Styling Options                                            //
  //////////////////////////////////////////////////////////////////////////////////////////////////////////
  /*
      Available installed fonts:
      - 'Helvetica Neue'
      - 'Raleway, sans-serif'
      - 'Noto Sans, sans-serif'
      - 'Inter, sans-serif'
      - 'Open Sans, sans-serif'
    */

  BACKGROUND_COLOR: "#C2C3C5",
  BUTTON: {
    color: "#FFFFFF",  // Red text
    backgroundColor: "#D01D22",  // White background
    //non hover state button colors follow global color, this is to prevent color clashing
    hoverState: {
      color: "#D01D22",
      borderColor: "#D01D22",
      backgroundColor: "#FFFFFF",
    },
  },
  BOT_NAME: "CIMB EVA",
  BOT_MSG: {
    //change values to string if u want to change the colors, otherwise leave as null
    color: null,
    backgroundColor: null,
    timeStampColor: null,
  },
  FONT_FAMILY: "Open Sans",
  GLOBAL_COLOR: "#D01D22",
  HEADER_COLOR: "#EC1D23",
  NOTIFICATION_BANNER: {
    color: "#ffffff",
    backgroundColor: "#9b131d",
    button: {
      color: "white",
      backgroundColor: "#f90103",
    },
  },
  PERSISTENT_MENU: {
    color: "",
    backgroundColor: "",
  },
  SEND_ICON_COLOR: "#EC1D23",
  SIDEBAR: {
    enableEndChatButton: false,
    color: "white",
    borderColor: "transparent",
    backgroundColor: "#780c07",
    logo: {
      width: "100%", // leave as auto unless width is broken. Either a number, 'auto' or '90%' (percentage based value)
      height: "auto", // leave as auto unless height is broken. Either a number, 'auto' or '90%' (percentage based value)
      url: "https://www.cimb.com.my/en/business.html",
    },
  },
  SHARE_BUTTON_BACKGROUND_COLOR: "#2d55b2cf",
  SHARE_ICON_COLOR: "white",
  USER_MESSAGE_COLOR: "white",
  WELCOME_COLOR: "#5f7375",
};

export default settings;
